import React from 'react';

export default function Loading() {
  return (
    <div>
      <h1>loading...</h1>
    </div>
  );
}
